module.exports = __webpack_public_path__ + "assets/images/igg.2a4cbea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kits/igg.png
// module id = 817
// module chunks = 1